export interface RouteInfo {
  title: string;
  icon: string;
  module: string;
}

const RouteMapsecsaude: { [key: string]: RouteInfo } = {
  // Home
  '/secsaude/home/inicio': {
    title: 'Home / Início',
    icon: 'home',
    module: 'Home',
  },

  // Meus Dados
  '/secsaude/meusdados/usuario': {
    title: 'Meus Dados / Usuário',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/secsaude/meusdados/logs': {
    title: 'Meus Dados / Meus Logs',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/secsaude/meusdados/acessos': {
    title: 'Meus Dados / Meus Acessos',
    icon: 'person',
    module: 'Meus Dados',
  },

  // MedSUS
  ////////////////// MedSUS
  '/secsaude/medsus/gestao': {
    title: 'MedSUS / Gestão MedSUS',
    icon: 'medication',
    module: 'MedSUS',
  },
  '/secsaude/medsus/gestao/dadosgerais': {
    title: 'MedSUS / Gestão MedSUS / Dados Gerais',
    icon: 'medication',
    module: 'MedSUS',
  },
  '/secsaude/medsus/gestao/:id/dadosgerais': {
    title: 'MedSUS / Gestão MedSUS / Dados Gerais',
    icon: 'medication',
    module: 'MedSUS',
  },

  // Produtos DAF
  ////////////////// Produtos
  '/secsaude/produtosdaf/produtos': {
    title: 'Produtos DAF / Produtos Farmacêuticos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/produtos/ficha/dadosgerais': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/produtos/ficha/:id/dadosgerais': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto Farmacêutico',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/produtos/ficha/vinculos': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto Farmacêutico',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/produtos/ficha/:id/vinculos': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto Farmacêutico',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// Denominações Genéricas
  '/secsaude/produtosdaf/denominacoes': {
    title: 'Produtos DAF / Denominações Genéricas',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/denominacoes/ficha/dadosgerais': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/denominacoes/ficha/:id/dadosgerais': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/denominacoes/ficha/vinculos': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/denominacoes/ficha/:id/vinculos': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// Kits de Produtos
  '/secsaude/produtosdaf/kits': {
    title: 'Produtos DAF / Kits de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/kits/ficha/dadosgerais': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/kits/ficha/:id/dadosgerais': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/kits/ficha/vinculos': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/secsaude/produtosdaf/kits/ficha/:id/vinculos': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// Programação
  '/secsaude/programacao/basico': {
    title: 'Programação / Componente Básico',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/basico/ficha/dadosgerais': {
    title:
      'Programação / Componente Básico / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/basico/ficha/:id/dadosgerais': {
    title:
      'Programação / Componente Básico / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },

  '/secsaude/programacao/especializado': {
    title: 'Programação / Componente Especializado',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/especializado/ficha/dadosgerais': {
    title:
      'Programação / Componente Especializado / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/especializado/ficha/:id/dadosgerais': {
    title:
      'Programação / Componente Especializado / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/especializado/ficha/notificacoes': {
    title:
      'Programação / Componente Especializado / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/especializado/ficha/entregas': {
    title:
      'Programação / Componente Especializado / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },

  '/secsaude/programacao/estrategico': {
    title: 'Programação / Componente Estratégico',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/estrategico/ficha/dadosgerais': {
    title:
      'Programação / Componente Estratégico / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/estrategico/ficha/:id/dadosgerais': {
    title:
      'Programação / Componente Estratégico / Programação de Produtos Farmacêuticos',
    icon: 'checklist',
    module: 'Programação',
  },

  '/secsaude/programacao/entregas': {
    title: 'Programação / Entregas',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/entregas/ficha/dadosgerais': {
    title: 'Programação / Entregas',
    icon: 'checklist',
    module: 'Programação',
  },
  '/secsaude/programacao/entregas/ficha/:id/dadosgerais': {
    title: 'Programação / Entregas',
    icon: 'checklist',
    module: 'Programação',
  },

  // Adm
  '/secsaude/adm/usuarios': {
    title: 'Admin / Lista de Usuários',
    icon: 'settings',
    module: 'Admin',
  },

  '/secsaude/adm/usuarios/ficha/:id/dadosgerais': {
    title: 'Admin / Lista de Usuários / Dados do Usuário',
    icon: 'settings',
    module: 'Admin',
  },
  '/secsaude/adm/logs': {
    title: 'Admin / Logs',
    icon: 'settings',
    module: 'Admin',
  },
  '/secsaude/adm/acessos': {
    title: 'Admin / Acessos',
    icon: 'settings',
    module: 'Admin',
  },

  '/secsaude/adm/relatorios': {
    title: 'Admin / Relatórios Gerados',
    icon: 'settings',
    module: 'Relatórios Gerados',
  },

  '/secsaude/adm/historicodert': {
    title: 'Admin / Histórico de RT',
    icon: 'settings',
    module: 'Histórico de RT',
  },

  '/secsaude/adm/historicodevinculacoes': {
    title: 'Admin / Histórico de Vinculações',
    icon: 'settings',
    module: 'Histórico de Vinculações',
  },

  // Página não encontrada
  '/': { title: 'Página não encontrada', icon: 'error', module: 'Erro!' }, // Rota genérica |* lidar com rotas não encontradas *|
};

export default RouteMapsecsaude;
